module.exports = __webpack_public_path__ + "static/media/carbon_information.68bbfec6.svg";